export default __webpack_public_path__ + "static/media/sd-anna-color@2x.573f9db1.png";